export default __webpack_public_path__ + "static/media/cigar2.e60f5036.jpg";